import { extra } from "./extra";

export const trust = {
  reg: "357/4/2022",
  phone: "+918714560216",
  phoneShow: "+91 8714 560 216",
  email: "olappamannatrust@gmail.com",
  bank: { acc: "002605300003187", ifsc: "DLXB0000026", name: "Dhanlaxmi Bank", branch: "Kongad" },
  equipment: [38000, 5000, 5000, 15000, 1200, 1000],
};


export const content = {
  en: {
    brand: "Olappamanna Bhagavathi Charitable Trust",
    brandSub: "Thiru Kunnappullikkavu, Ezhakkad",
    motto: "Charity Leads to Prosperity — Rig Veda",
    reg: "Reg. No.",
    address: "Thiru Kunnappullikkavu, Ezhakkad, Mundur, Palakkad - 678 635",
    nav: { home: "Home", about: "About", activities: "Activities", dialysis: "Dialysis Centre", oldAge: "Old Age Home", gallery: "Gallery", contact: "Contact Us" },
    home: {
      title: "Let us move forward together and extend a helping hand to the deserving",
      sub: "Food, medical equipment, dialysis support and care for poor and bedridden patients in Mundur and Kongad, Palakkad.",
      donate: "Donate Now", learn: "Our Story",
      impact: [["2022", "Year established"], ["30", "Temples linked to our founder"], ["2", "Panchayats served"], ["₹800", "Monthly food kit"]],
      whatTitle: "How we help",
      whatSub: "Six ways your support reaches families in need.",
      moreLink: "See all activities",
      appealTitle: "Your small contribution can bring hope to a family.",
      appealText: "Each month we give bedridden patients a food kit with about 10 kg of rice and 10 essential household provisions, worth around ₹800.",
    },
    homeShrine: {
      tag: "Our temple",
      title: "Thiru Kunnappulli Bhagavathy Temple",
      text: "The temple at Thiru Kunnappullikkavu, Kongad is the heart of our community and the home of our charitable work. Devotees come here to pray, and the temple stands behind the Trust in caring for those in need.",
      facts: [
        ["Deity", "Goddess Devi (Kunnappulli Amma)"],
        ["Darshanam", "Facing north"],
        ["Management", "Administered by Olappamanna Mana, together with a local committee of villagers"],
      ],
      festTitle: "Major festivals & rituals",
      fest: [
        ["Kummatti", "Malayalam month of Kumbham", "February – March"],
        ["Vishu Vela", "Malayalam month of Medam", "April – May"],
      ],
    },
    homeTemple: {
      tag: "Temple support",
      pct: "20%",
      pctLabel: "of hundial income",
      title: "Our temple stands behind our service",
      text: "Thiru Kunnappulli Bhagavathy Temple contributes 20% of its hundial (offering box) income to the Charitable Trust to support its operations and charitable activities.",
      note: "Every offering made at the temple also helps care for patients in need.",
    },
    homeQuotes: {
      items: [
        ["“The best way to find yourself is to lose yourself in the service of others.”", "Mahatma Gandhi"],
        ["“The smallest act of kindness is worth more than the grandest intention.”", "Oscar Wilde"],
      ],
    },
    aboutQuote: {
      text: "True charity is giving as a duty, without expecting anything in return.",
    },
    about: {
      title: "About the Trust",
      sub: "Founded in 2022 at Thiru Kunnappullikkavu, Ezhakkad.",
      paras: [
        "The Olappamanna Bhagavathi Charitable Trust was established in 2022 at Thiru Kunnappullikkavu, Ezhakkad, with Registration No. 357/4/2022. It was formed at the special initiative of Sri O.M.C. Neelakandan Namboothiripad, who is associated with the management of about 30 temples across Palakkad district.",
        "Our guiding principle is “Living Together and Engaging in Humanitarian Service.”",
        "We work with government palliative care centres, primary healthcare institutions, doctors and health inspectors in the Kongad and Mundur panchayats.",
      ],
      officeTitle: "Office bearers",
      office: [["President", "O.M.C. Neelakandan Namboothirippad, Palappuram"], ["Convener", "K.M. Pradeep, Sreevalsam Punathil House, Ezhakkad - 678 631"], ["Treasurer", "K.C. Venugopal, Pallikurup P.O., Mannarkkad - 678 582"]],
      thanks: "We sincerely thank everyone who has helped us, and we ask kind-hearted people to keep offering their support, cooperation and suggestions.",
    },
    actQuotes: {
      first: "A little kindness can change someone’s entire world.",
      second: "The whole world is one family.",
    },
    act: {
      title: "Our Activities", sub: "Regular help for poor, helpless and bedridden patients.",
      items: [
        ["Food assistance", "With the palliative care units in Mundur and Kongad, we regularly give food kits with rice, groceries and other essentials."],
        ["Recreational trips", "With health workers, ward members and temple office-bearers, we take bedridden patients on outings to places such as Malampuzha and Kanjirappuzha gardens."],
        ["Medical clinic", "A clinic the people of Kunnappullikkavu long wished for has been running for two years in a new building on the temple grounds."],
        ["Support for bedridden patients", "We renovate unsafe homes of palliative care patients and provide oxygen concentrators, surgical cots, wheelchairs and waterbeds. We also give study materials and financial help to underprivileged students."],
        ["Kidney patient assistance", "We give dialysis kits and travel money for dialysis visits, within the limits of our funds."],
        ["Land and house donated", "Smt. Saraswathi Amma of Puthuriyaram has donated four cents of land and a 900 sq ft concrete house for the trust's future work, after her lifetime."],
      ],
      equipTitle: "Equipment we provide", equipSub: "Approximate cost of each item.",
      head: ["No.", "Equipment", "Amount"],
      equip: ["Oxygen concentrator", "Wheelchair", "Waterbed", "Surgical cot", "Dialysis kit", "Walker"],
      futureTitle: "Future plans",
      future: ["Build our own office", "Open a dialysis centre", "Open a medical clinic", "Set up an old age home", "Provide life-saving equipment, including beds"],
    },
    dia: {
      title: "Dialysis Centre", sub: "Our planned centre for kidney patients in Mundur, Kongad and nearby areas.",
      nowTitle: "What we do today",
      now: ["Provide dialysis kits (₹1,200 each)", "Pay travel costs to dialysis facilities", "Help patients with serious kidney illness, within our funds"],
      planTitle: "What we plan", plan: "We want to set up our own dialysis centre so patients no longer travel far for treatment. It will be funded by public donations and the trust's funds.",
      cta: "Help us build it",
    },
    old: {
      title: "Old Age Home", sub: "A planned home for elders in Mundur, Kongad and the surrounding areas.",
      planTitle: "Our plan", plan: "We intend to set up an old age home at a suitable location to care for those who have no one to look after them. We will fund it through public donations and the trust's funds.",
      landTitle: "A first step", land: "Smt. Saraswathi Amma of Puthuriyaram has donated four cents of land and a 900 sq ft concrete house for the trust's future activities, after her lifetime.",
      cta: "Support this plan",
    },
    gal: { title: "Gallery", sub: "Moments from our work.", close: "Close" },
    con: {
      title: "Contact Us", sub: "Write or call us. We will reply as soon as we can.",
      phone: "Phone", email: "Email", addr: "Address",
      name: "Your name", mail: "Your email", msg: "Your message", send: "Send message",
      donTitle: "Donate by bank transfer", donText: "Your small contribution can bring hope to a family.",
      acc: "Account number", ifsc: "IFSC code", bank: "Bank", branch: "Branch", copy: "Copy", copied: "Copied",
    },
  },
  ml: {
    brand: "ഒളപ്പമണ്ണ ഭഗവതി ചാരിറ്റബിൾ ട്രസ്റ്റ്",
    brandSub: "തിരുകുന്നപ്പുള്ളിക്കാവ്, എഴക്കാട്",
    motto: "ദാനം ഐശ്വര്യത്തിലേക്ക് നയിക്കുന്നു — ഋഗ്വേദം",
    reg: "രജി. നമ്പർ",
    address: "തിരുകുന്നപ്പുള്ളിക്കാവ്, എഴക്കാട്, മുണ്ടൂർ, പാലക്കാട് - 678 635",
    nav: { home: "ഹോം", about: "ഞങ്ങളെക്കുറിച്ച്", activities: "പ്രവർത്തനങ്ങൾ", dialysis: "ഡയാലിസിസ് കേന്ദ്രം", oldAge: "വൃദ്ധസദനം", gallery: "ഗാലറി", contact: "ബന്ധപ്പെടുക" },
    home: {
      title: "ഒത്തൊരുമയോടെ മുന്നേറാം, അർഹരായവർക്ക് കരുതലും കൈത്താങ്ങുമാകാം.",
      sub: "പാലക്കാട് മുണ്ടൂർ, കോങ്ങാട് പ്രദേശങ്ങളിലെ നിർധനരും കിടപ്പുരോഗികളുമായവർക്ക് ഭക്ഷണം, വൈദ്യ ഉപകരണങ്ങൾ, ഡയാലിസിസ് സഹായം, പരിചരണം.",
      donate: "സംഭാവന നൽകൂ", learn: "ഞങ്ങളുടെ കഥ",
      impact: [["2022", "സ്ഥാപിച്ച വർഷം"], ["30", "സ്ഥാപകന് ബന്ധമുള്ള ക്ഷേത്രങ്ങൾ"], ["2", "പഞ്ചായത്തുകൾ"], ["₹800", "പ്രതിമാസ ഭക്ഷ്യക്കിറ്റ്"]],
      whatTitle: "ഞങ്ങൾ എങ്ങനെ സഹായിക്കുന്നു",
      whatSub: "നിങ്ങളുടെ സഹായം ആവശ്യക്കാരായ കുടുംബങ്ങളിലെത്തുന്ന ആറ് വഴികൾ.",
      moreLink: "എല്ലാ പ്രവർത്തനങ്ങളും കാണുക",
      appealTitle: "നിങ്ങളുടെ ചെറിയ സംഭാവന ഒരു കുടുംബത്തിന് പ്രതീക്ഷയാകും.",
      appealText: "ഓരോ മാസവും കിടപ്പുരോഗികൾക്ക് ഏകദേശം 10 കിലോ അരിയും 10 തരം അവശ്യ വീട്ടുസാധനങ്ങളും അടങ്ങിയ, ഏകദേശം ₹800 വിലയുള്ള ഭക്ഷ്യക്കിറ്റ് നൽകുന്നു.",
    },
    homeShrine: {
      tag: "ഞങ്ങളുടെ ക്ഷേത്രം",
      title: "തിരു കുന്നപ്പുള്ളി ഭഗവതി ക്ഷേത്രം",
      text: "കോങ്ങാട് തിരുകുന്നപ്പുള്ളിക്കാവിലെ ക്ഷേത്രമാണ് ഞങ്ങളുടെ നാടിന്റെ ഹൃദയവും ജീവകാരുണ്യ പ്രവർത്തനങ്ങളുടെ കേന്ദ്രവും. ഭക്തർ ഇവിടെ പ്രാർഥിക്കാനെത്തുന്നു; ആവശ്യക്കാർക്ക് കരുതലേകുന്ന ട്രസ്റ്റിന് ക്ഷേത്രം താങ്ങായി നിൽക്കുന്നു.",
      facts: [
        ["പ്രതിഷ്ഠ", "ദേവി (കുന്നപ്പുള്ളി അമ്മ)"],
        ["ദർശനം", "വടക്കോട്ട് ദർശനം"],
        ["ഭരണം", "ഒളപ്പമണ്ണ മനയുടെ ഉടമസ്ഥതയിലും ഭരണത്തിലും, നാട്ടുകാരടങ്ങുന്ന പ്രാദേശിക കമ്മിറ്റിയോടൊപ്പം"],
      ],
      festTitle: "പ്രധാന ഉത്സവങ്ങളും ആചാരങ്ങളും",
      fest: [
        ["കുമ്മാട്ടി", "മലയാള മാസം കുംഭം", "ഫെബ്രുവരി – മാർച്ച്"],
        ["വിഷു വേല", "മലയാള മാസം മേടം", "ഏപ്രിൽ – മേയ്"],
      ],
    },
    homeTemple: {
      tag: "ക്ഷേത്രത്തിന്റെ പിന്തുണ",
      pct: "20%",
      pctLabel: "ഹുണ്ടിയൽ വരുമാനം",
      title: "ഞങ്ങളുടെ സേവനത്തിന് ക്ഷേത്രത്തിന്റെ കരുത്ത്",
      text: "തിരു കുന്നപ്പുള്ളി ഭഗവതി ക്ഷേത്രം ഹുണ്ടിയൽ (ഭണ്ഡാരം) വരുമാനത്തിന്റെ 20% ചാരിറ്റബിൾ ട്രസ്റ്റിന്റെ പ്രവർത്തനങ്ങൾക്കും ജീവകാരുണ്യ പ്രവർത്തനങ്ങൾക്കുമായി സംഭാവന ചെയ്യുന്നു.",
      note: "ക്ഷേത്രത്തിൽ സമർപ്പിക്കുന്ന ഓരോ വഴിപാടും ആവശ്യക്കാരായ രോഗികളുടെ പരിചരണത്തിനും സഹായമാകുന്നു.",
    },
    homeQuotes: {
      items: [
        ["“മറ്റുള്ളവരെ സേവിക്കുന്നതിലൂടെ സ്വയം കണ്ടെത്തുന്നതാണ് സ്വയം കണ്ടെത്താനുള്ള ഏറ്റവും നല്ല മാർഗം.”", "മഹാത്മാ ഗാന്ധി"],
        ["“ഏറ്റവും വലിയ ഉദ്ദേശ്യത്തേക്കാൾ വിലപ്പെട്ടതാണ് ഏറ്റവും ചെറിയ ദയാപ്രവൃത്തിപോലും.”", "ഓസ്കാർ വൈൽഡ്"],
      ],
    },
    aboutQuote: {
      text: "പ്രതിഫലമൊന്നും പ്രതീക്ഷിക്കാതെ, കടമയെന്ന ബോധത്തോടെ നൽകുന്നതാണ് യഥാർത്ഥ ദാനം.",
    },
    about: {
      title: "ട്രസ്റ്റിനെക്കുറിച്ച്",
      sub: "2022-ൽ തിരുകുന്നപ്പുള്ളിക്കാവ്, എഴക്കാട് സ്ഥാപിതം.",
      paras: [
        "ഒളപ്പമണ്ണ ഭഗവതി ചാരിറ്റബിൾ ട്രസ്റ്റ് 2022-ൽ എഴക്കാട് തിരുകുന്നപ്പുള്ളിക്കാവിൽ (രജിസ്ട്രേഷൻ നമ്പർ 357/4/2022) സ്ഥാപിതമായി. പാലക്കാട് ജില്ലയിലെ ഏകദേശം 30 ക്ഷേത്രങ്ങളുടെ ഭരണവുമായി ബന്ധപ്പെട്ട ശ്രീ ഒ.എം.സി. നീലകണ്ഠൻ നമ്പൂതിരിപ്പാടിന്റെ പ്രത്യേക മുൻകൈയിലാണ് ഇത് രൂപീകരിച്ചത്.",
        "“ഒരുമിച്ച് ജീവിക്കുക, മാനവസേവനത്തിൽ ഏർപ്പെടുക” എന്നതാണ് ഞങ്ങളുടെ മാർഗനിർദേശക തത്വം.",
        "കോങ്ങാട്, മുണ്ടൂർ പഞ്ചായത്തുകളിലെ സർക്കാർ പാലിയേറ്റീവ് കേന്ദ്രങ്ങൾ, പ്രാഥമികാരോഗ്യ സ്ഥാപനങ്ങൾ, ഡോക്ടർമാർ, ഹെൽത്ത് ഇൻസ്പെക്ടർമാർ എന്നിവരുമായി സഹകരിച്ചാണ് ഞങ്ങൾ പ്രവർത്തിക്കുന്നത്.",
      ],
      officeTitle: "ഭാരവാഹികൾ",
      office: [["പ്രസിഡന്റ്", "ഒ.എം.സി. നീലകണ്ഠൻ നമ്പൂതിരിപ്പാട്, പാലപ്പുറം"], ["കൺവീനർ", "കെ.എം. പ്രദീപ്, ശ്രീവത്സം പുനത്തിൽ ഹൗസ്, എഴക്കാട് - 678 631"], ["ട്രഷറർ", "കെ.സി. വേണുഗോപാൽ, പള്ളിക്കുറുപ്പ് പി.ഒ., മണ്ണാർക്കാട് - 678 582"]],
      thanks: "ഞങ്ങളെ സഹായിച്ച എല്ലാവരോടും ആത്മാർഥമായി നന്ദി പറയുന്നു. സന്മനസ്സുള്ളവർ തുടർന്നും പിന്തുണയും സഹകരണവും നിർദേശങ്ങളും നൽകണമെന്ന് അഭ്യർഥിക്കുന്നു.",
    },
    actQuotes: {
      first: "ഒരു ചെറിയ കാരുണ്യപ്രവൃത്തി ഒരാളുടെ ലോകം മുഴുവൻ മാറ്റിമറിച്ചേക്കാം.",
      second: "ലോകം മുഴുവൻ ഒരു കുടുംബമാണ്.",
    },
    act: {
      title: "ഞങ്ങളുടെ പ്രവർത്തനങ്ങൾ", sub: "നിർധനരും നിസ്സഹായരുമായ കിടപ്പുരോഗികൾക്ക് സ്ഥിരമായ സഹായം.",
      items: [
        ["ഭക്ഷ്യസഹായം", "മുണ്ടൂർ, കോങ്ങാട് പാലിയേറ്റീവ് യൂണിറ്റുകളുമായി ചേർന്ന് അരി, പലവ്യഞ്ജനങ്ങൾ തുടങ്ങിയ അവശ്യസാധനങ്ങളടങ്ങിയ കിറ്റുകൾ സ്ഥിരമായി നൽകുന്നു."],
        ["വിനോദയാത്രകൾ", "ആരോഗ്യപ്രവർത്തകർ, വാർഡ് അംഗങ്ങൾ, ക്ഷേത്രഭാരവാഹികൾ എന്നിവരുടെ സഹായത്തോടെ കിടപ്പുരോഗികളെ മലമ്പുഴ, കാഞ്ഞിരപ്പുഴ ഉദ്യാനങ്ങളിലേക്ക് യാത്ര കൊണ്ടുപോയി."],
        ["മെഡിക്കൽ ക്ലിനിക്", "കുന്നപ്പുള്ളിക്കാവ് നിവാസികൾ ഏറെക്കാലമായി ആഗ്രഹിച്ച ക്ലിനിക്, ക്ഷേത്രവളപ്പിലെ പുതിയ കെട്ടിടത്തിൽ രണ്ടു വർഷമായി പ്രവർത്തിക്കുന്നു."],
        ["കിടപ്പുരോഗികൾക്കുള്ള പിന്തുണ", "പാലിയേറ്റീവ് രോഗികളുടെ താമസയോഗ്യമല്ലാത്ത വീടുകൾ നവീകരിക്കുകയും ഓക്സിജൻ കോൺസെൻട്രേറ്റർ, സർജിക്കൽ കോട്ട്, വീൽചെയർ, വാട്ടർബെഡ് എന്നിവ നൽകുകയും ചെയ്യുന്നു. നിർധന വിദ്യാർഥികൾക്ക് പഠനസാമഗ്രികളും ധനസഹായവും നൽകുന്നു."],
        ["വൃക്കരോഗികൾക്ക് സഹായം", "ഫണ്ടിന്റെ പരിധിക്കുള്ളിൽ ഡയാലിസിസ് കിറ്റുകളും ഡയാലിസിസ് കേന്ദ്രത്തിലേക്കുള്ള യാത്രാച്ചെലവും നൽകുന്നു."],
        ["ഭൂമിയും വീടും സംഭാവന", "പുതുരിയാരത്തെ ശ്രീമതി സരസ്വതി അമ്മ, ട്രസ്റ്റിന്റെ ഭാവി പ്രവർത്തനങ്ങൾക്കായി നാല് സെന്റ് ഭൂമിയും 900 ചതുരശ്ര അടി കോൺക്രീറ്റ് വീടും തന്റെ കാലശേഷം നൽകാമെന്ന് സംഭാവന ചെയ്തു."],
      ],
      equipTitle: "ഞങ്ങൾ നൽകുന്ന ഉപകരണങ്ങൾ", equipSub: "ഓരോന്നിന്റെയും ഏകദേശ ചെലവ്.",
      head: ["ക്ര.നം.", "ഉപകരണം", "തുക"],
      equip: ["ഓക്സിജൻ കോൺസെൻട്രേറ്റർ", "വീൽചെയർ", "വാട്ടർബെഡ്", "സർജിക്കൽ കോട്ട്", "ഡയാലിസിസ് കിറ്റ്", "വാക്കർ"],
      futureTitle: "ഭാവി പദ്ധതികൾ",
      future: ["സ്വന്തമായി ഓഫീസ് കെട്ടിടം പണിയുക", "ഡയാലിസിസ് കേന്ദ്രം സ്ഥാപിക്കുക", "മെഡിക്കൽ ക്ലിനിക് സ്ഥാപിക്കുക", "വൃദ്ധസദനം സ്ഥാപിക്കുക", "കിടക്കകളുൾപ്പെടെ ജീവൻരക്ഷാ ഉപകരണങ്ങൾ നൽകുക"],
    },
    dia: {
      title: "ഡയാലിസിസ് കേന്ദ്രം", sub: "മുണ്ടൂർ, കോങ്ങാട് പരിസരങ്ങളിലെ വൃക്കരോഗികൾക്കായി ഞങ്ങൾ ആസൂത്രണം ചെയ്യുന്ന കേന്ദ്രം.",
      nowTitle: "ഇപ്പോൾ ചെയ്യുന്നത്",
      now: ["ഡയാലിസിസ് കിറ്റുകൾ നൽകുന്നു (ഒന്നിന് ₹1,200)", "ഡയാലിസിസ് കേന്ദ്രത്തിലേക്കുള്ള യാത്രാച്ചെലവ് നൽകുന്നു", "ഗുരുതര വൃക്കരോഗികളെ ഫണ്ടിന്റെ പരിധിയിൽ സഹായിക്കുന്നു"],
      planTitle: "ഞങ്ങളുടെ പദ്ധതി", plan: "ചികിത്സയ്ക്കായി രോഗികൾക്ക് ദൂരയാത്ര വേണ്ടിവരാതിരിക്കാൻ സ്വന്തമായി ഡയാലിസിസ് കേന്ദ്രം സ്ഥാപിക്കാൻ ഞങ്ങൾ ആഗ്രഹിക്കുന്നു. പൊതുസംഭാവനകളും ട്രസ്റ്റ് ഫണ്ടും ഇതിനായി ഉപയോഗിക്കും.",
      cta: "നിർമാണത്തിൽ സഹായിക്കൂ",
    },
    old: {
      title: "വൃദ്ധസദനം", sub: "മുണ്ടൂർ, കോങ്ങാട് പരിസരങ്ങളിലെ വയോജനങ്ങൾക്കായി ആസൂത്രണം ചെയ്യുന്ന സദനം.",
      planTitle: "ഞങ്ങളുടെ പദ്ധതി", plan: "നോക്കാൻ ആരുമില്ലാത്തവരെ പരിചരിക്കാൻ അനുയോജ്യമായ സ്ഥലത്ത് വൃദ്ധസദനം സ്ഥാപിക്കാൻ ഞങ്ങൾ ഉദ്ദേശിക്കുന്നു. പൊതുസംഭാവനകളും ട്രസ്റ്റ് ഫണ്ടും ഇതിനായി ഉപയോഗിക്കും.",
      landTitle: "ആദ്യ ചുവട്", land: "പുതുരിയാരത്തെ ശ്രീമതി സരസ്വതി അമ്മ ട്രസ്റ്റിന്റെ ഭാവി പ്രവർത്തനങ്ങൾക്കായി നാല് സെന്റ് ഭൂമിയും 900 ചതുരശ്ര അടി കോൺക്രീറ്റ് വീടും തന്റെ കാലശേഷം നൽകാമെന്ന് സംഭാവന ചെയ്തു.",
      cta: "ഈ പദ്ധതിയെ പിന്തുണയ്ക്കൂ",
    },
    gal: { title: "ഗാലറി", sub: "ഞങ്ങളുടെ പ്രവർത്തനങ്ങളിലെ നിമിഷങ്ങൾ.", close: "അടയ്ക്കുക" },
    con: {
      title: "ബന്ധപ്പെടുക", sub: "ഞങ്ങൾക്ക് എഴുതുക അല്ലെങ്കിൽ വിളിക്കുക. കഴിയുന്നത്ര വേഗം മറുപടി നൽകാം.",
      phone: "ഫോൺ", email: "ഇമെയിൽ", addr: "വിലാസം",
      name: "നിങ്ങളുടെ പേര്", mail: "നിങ്ങളുടെ ഇമെയിൽ", msg: "നിങ്ങളുടെ സന്ദേശം", send: "സന്ദേശം അയയ്ക്കുക",
      donTitle: "ബാങ്ക് ട്രാൻസ്ഫർ വഴി സംഭാവന", donText: "നിങ്ങളുടെ ചെറിയ സംഭാവന ഒരു കുടുംബത്തിന് പ്രതീക്ഷയാകും.",
      acc: "അക്കൗണ്ട് നമ്പർ", ifsc: "ഐഎഫ്എസ്‌സി കോഡ്", bank: "ബാങ്ക്", branch: "ബ്രാഞ്ച്", copy: "പകർത്തുക", copied: "പകർത്തി",
    },
  },
};

Object.keys(extra).forEach((l) => Object.assign(content[l], extra[l]));